export default {
    controls: {
        undo: {
            title: 'Undo',
        },
        redo: {
            title: 'Redo',
        },
        bold: {
            title: 'Bold',
        },
        italic: {
            title: 'Italic',
        },
        underline: {
            title: 'Underline',
        },
        strikethrough: {
            title: 'Strike through',
        },
        code: {
            title: 'Code',
        },
        fontColor: {
            title: 'Font color',
            labels: {
                noColor: 'None',
            },
        },
        fontBackgroundColor: {
            title: 'Highlight color',
            labels: {
                noColor: 'None',
            },
        },
        linkAdd: {
            title: 'Add link',
            labels: {
                link: 'Link',
            },
            actions: {
                add: 'Add',
                cancel: 'Cancel',
            },
        },
        linkRemove: {
            title: 'Remove link',
        },
        image: {
            title: 'Insert image',
            actions: {
                upload: 'Upload image',
                url: 'By URL',
                add: 'Add',
                cancel: 'Cancel',
                alignLeft: 'Align left',
                alignCenter: 'Align center',
                alignRight: 'Align right',
                remove: 'Remove image',
                resize: 'Resize',
            },
            labels: {
                dropImageHere: 'Drop image here or click to upload',
                width: 'Width',
                height: 'Height',
                url: 'URL',
                insertOptions: 'Insert image options',
                editOptions: 'Image options',
            },
            errorMessages: {
                notValidImage: 'Not a valid image',
            },
        },
        blockType: {
            title: 'Block format',
            labels: {
                normal: 'Normal',
                header1: 'Header 1',
                header2: 'Header 2',
                header3: 'Header 3',
                header4: 'Header 4',
                header5: 'Header 5',
                header6: 'Header 6',
            },
        },
        fontSize: {
            title: 'Font size',
            labels: {
                default: 'default',
            },
        },
        fontFamily: {
            title: 'Font type',
            labels: {
                default: 'default',
            },
        },
        textAlign: {
            title: 'Align text',
            actions: {
                alignLeft: 'Left',
                alignCenter: 'Center',
                alignRight: 'Right',
                justify: 'Justify',
            },
        },
        unorderedList: {
            title: 'Unordered list',
        },
        orderedList: {
            title: 'Ordered list',
        },
    },
};
